import { configureStore } from '@reduxjs/toolkit'

import appApi from './api'
import notificationPanel from './slice/NotificiationPanel'
import office from './slice/OfficeSlice'
import client from './slice/ClientSlice'
import rentals from './slice/RentalsSlice'
import searchedUser from './slice/searchedUser'


export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(appApi.middleware),
  reducer: {
    notificationPanel,
    office,
    client,
    rentals,
    searchedUser,
    [appApi.reducerPath]: appApi.reducer,
  }
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export default store
